import { render, staticRenderFns } from "./AVehicleFilterBox.vue?vue&type=template&id=889bd708"
import script from "./AVehicleFilterBox.vue?vue&type=script&lang=js"
export * from "./AVehicleFilterBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports